import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class EventEmitter {
  constructor() {
    _defineProperty(this, "events", {});
    this.events = {};
  }
  on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
    return this;
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (this.events[event]) {
      this.events[event].forEach(listener => listener(...args));
    }
  }
}
flarum.reg.add('core', 'common/utils/EventEmitter', EventEmitter);